import { Navigate } from 'react-router-dom';
import { useSessionStore } from '@/stores/session';

/** `/` → last workspace (localStorage.lastWorkspaceSlug) → first membership → /onboarding. */
export function RootRedirect() {
  const me = useSessionStore((s) => s.me);
  if (!me) return null;
  let last: string | null = null;
  try {
    last = JSON.parse(localStorage.getItem('lastWorkspaceSlug') ?? 'null');
  } catch {
    /* ignore */
  }
  const match = me.memberships.find((m) => m.workspace.slug === last) ?? me.memberships[0];
  return <Navigate to={match ? `/w/${match.workspace.slug}` : '/onboarding'} replace />;
}
